import React, {useEffect, useState} from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import StoriesBlock from '../../components/Stories/StoriesBlock/StoriesBlock';
import './PageLive.scss';
import './PageLive-media.scss';
import { Props } from './interfaces';
import { MetaTags } from '../../services/content/Constants';
import SliderLive from '../../components/SliderLive/SliderLive';
import Button from '../../components/Button/Button';
import SliderNewsList from '../../components/SliderNewsList/SliderNewsList';
import Content from '../../components/Content/Content';
import { CardNews } from '../../redux/services/GlobalFunctionsTsx.ts';
import { MediaContent } from '../../services/GlobalFunctions';
import {ServiceData} from "../../redux/services/ServiceRedux";
import {IArticle} from "../PageArticle/interfaces";
import CardBlog from "../../components/CardBlog/CardBlog";
import CardNew from "../../components/CardNew/CardNew";

const PageLive = ({ stories }: Props) => {
  const defaultCount = 10;
  const [count, setCount] = useState(defaultCount);
  const [blog, setBlog] = useState([]);
  const [blogMain, setBlogMain] = useState([]);
  const [blogPopular, setBlogPopular] = useState([]);

  useEffect(() => {
    ServiceData.getBlog().then(({all, main, popular}) => {
      // @ts-ignore
      setBlog(all);
      // @ts-ignore
      setBlogMain(main);
      // @ts-ignore
      setBlogPopular(popular)
    });
  }, []);

  const newsList = blog;
  const ShowMore = () => {
    if (newsList.length > count) {
      setCount(count + 10);
    } else {
      setCount(defaultCount);
    }
  };

  return (
    <div className="page-live">

      {stories.length ? <StoriesBlock stories={stories} /> : null}

      <Content
        noLazy
        padding={{ paddingMain: { top: 0, bottom: 0 }, paddingMob: { top: 0, bottom: 40 } }}
        block={
          <div className="page-live__main">
            <div className="page-live__bg-7"></div>
            <div className="page-live__news-slider">
              {MediaContent(<SliderLive slides={blogMain} />, <SliderNewsList slides={blogMain} />)}
            </div>
          </div>
        }
      />

      {/* {blogPopular.length ? (
        <Content
          block={<SliderNewsList slides={blogPopular} title="Популярное" />}
          padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        />
      ) : null} */}

      <Content
        padding={{ paddingMain: { top: 60, bottom: 60 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <div className="page-live__news">
            <div className="page-live__bg-1-1"></div>
            <div className="page-live__bg-1-2"></div>
            <div className="page-live__grid">
              {newsList.map((item: IArticle, i) => (i < count
                ? ((i % 10 === 0 || i % 10 === 6) ? <CardBlog key={item.id} stretchy {...item}/> : <CardNew key={item.id} {...item}/>)
                : null))}
            </div>
          </div>
        }
      />
      {newsList.length > count ? (
        <div className="page-live__grid-button">
          <Button text="Показать еще" onClick={ShowMore} type="border" />
        </div>
      ) : null}
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageLive));
